import { ChakraBox, ChakraFlex, Modal } from '@equip.health/ui';

import ClinicalMeasurementCard from './ClinicalMeasurementCard';
import { MeasurementCardDefinition } from './ClinicalMeasurementsOverview';
import { ObservationCards, observationTypeToVitalsTabIndex } from './constants';
import KeyVitals from './key-vitals';
import SinglePatientReportCard from './SinglePatientReportCard';
import PatientDetailView from '../../../assessments/common/patient-details';
import Loading from '~/pages/loading';

export type ClinicalMeasurementModalData = { profileType: ObservationCards };

type ClinicalMeasurementModalProps = {
  bmiCardData?: MeasurementCardDefinition;
  closeModal: () => void;
  patient: Patient;
  patientClinicalProfile?: PatientClinicalProfile;
  patientPreferredFullName: string;
  showClinicalMeasurementModal: ClinicalMeasurementModalData;
  targetWeightCardData?: MeasurementCardDefinition;
};

const getCard = (cardData: MeasurementCardDefinition) => {
  if (!cardData?.mainObservation?.value) {
    return <></>;
  }
  return (
    <ChakraBox key={cardData.title} marginBottom="10px">
      <ClinicalMeasurementCard {...cardData} />
    </ChakraBox>
  );
};

const getReportCard = (patientId: string) =>
  patientId && (
    <ChakraBox key="single-patient-report" marginBottom="10px">
      <SinglePatientReportCard patientId={patientId} />
    </ChakraBox>
  );

const ClinicalMeasurementModal = ({
  bmiCardData,
  closeModal,
  patient,
  patientClinicalProfile,
  patientPreferredFullName,
  showClinicalMeasurementModal,
  targetWeightCardData,
}: ClinicalMeasurementModalProps) => {
  return (
    <Modal
      footerContent={null}
      hideCloseButton
      hideHeader
      id="clinical-measurement"
      isOpen={Boolean(showClinicalMeasurementModal)}
      modalBodyPadding="0"
      modalContentPadding="0"
      onClose={closeModal}
      size="full"
      title={null}
    >
      {!patientClinicalProfile && <Loading />}
      {patientClinicalProfile && (
        <ChakraFlex minHeight="100vh">
          <PatientDetailView
            cards={[
              getReportCard(patient.userId),
              getCard(bmiCardData),
              getCard(targetWeightCardData),
            ]}
            id="clinical-measurement__patient-details"
            patient={patient}
            patientClinicalProfile={patientClinicalProfile}
            patientPreferredFullName={patientPreferredFullName}
          />
          <KeyVitals
            closeModal={closeModal}
            initialTabIndex={
              observationTypeToVitalsTabIndex[
                showClinicalMeasurementModal?.profileType
              ]
            }
            patientId={patient?.userId}
          />
        </ChakraFlex>
      )}
    </Modal>
  );
};

export default ClinicalMeasurementModal;
